<template>
  <div class="pushes">
    <!-- 统计卡片 -->
    <el-row :gutter="20" class="stat-row">
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value">{{ stats.total || 0 }}</div>
          <div class="stat-label">{{ $t('pushes.statTotal') }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value" style="color: #67C23A;">{{ stats.sent || 0 }}</div>
          <div class="stat-label">{{ $t('pushes.statSent') }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="stat-card">
          <div class="stat-value" style="color: #409EFF;">{{ stats.read || 0 }}</div>
          <div class="stat-label">{{ $t('pushes.statRead') }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card>
      <div slot="header" class="card-header">
        <span>{{ $t('pushes.title') }}</span>
      </div>

      <!-- 搜索栏 -->
      <el-form inline class="search-form">
        <el-form-item :label="$t('pushes.status')">
          <el-select v-model="search.status" :placeholder="$t('pushes.allStatus')" clearable @change="handleSearch">
            <el-option :label="$t('pushes.sent')" value="sent"></el-option>
            <el-option :label="$t('pushes.read')" value="read"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pushes.type')">
          <el-select v-model="search.type" :placeholder="$t('pushes.allTypes')" clearable @change="handleSearch">
            <el-option :label="$t('pushes.manual')" value="manual"></el-option>
            <el-option :label="$t('pushes.auto')" value="auto"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pushes.language')">
          <el-select v-model="search.language" :placeholder="$t('pushes.allLanguages')" clearable @change="handleSearch">
            <el-option :label="$t('common.langZh')" value="zh"></el-option>
            <el-option :label="$t('common.langEn')" value="en"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pushes.keyword')">
          <el-input v-model="search.keyword" :placeholder="$t('pushes.kwPlaceholder')" clearable @clear="handleSearch"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pushes.studyId')">
          <el-input v-model="search.studyId" :placeholder="$t('pushes.studyIdPlaceholder')" clearable @clear="handleSearch"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pushes.colNickname')">
          <el-input v-model="search.nickname" :placeholder="$t('pushes.nicknamePlaceholder')" clearable @clear="handleSearch"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pushes.dateRange')">
          <el-date-picker
            v-model="search.dateRange"
            type="daterange"
            :range-separator="$t('pushes.rangeSep')"
            :start-placeholder="$t('pushes.rangeStart')"
            :end-placeholder="$t('pushes.rangeEnd')"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{ $t('pushes.search') }}</el-button>
          <el-button @click="resetSearch">{{ $t('pushes.reset') }}</el-button>
        </el-form-item>
      </el-form>

      <!-- 推送列表 -->
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" :label="$t('pushes.colId')" width="70"></el-table-column>
        <el-table-column prop="title" :label="$t('pushes.colTitle')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="content" :label="$t('pushes.colContent')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.content || scope.row.contentTitle || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="targetInfo" :label="$t('pushes.colTarget')" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" :label="$t('pushes.colType')" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'auto' || scope.row.pushType === 'scheduled' ? 'warning' : ''" size="mini">
              {{ scope.row.pushType === 'scheduled' || scope.row.pushType === 'auto' ? $t('pushes.auto') : $t('pushes.manual') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="language" :label="$t('pushes.colLanguage')" width="80">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.language === 'en' ? 'warning' : 'success'">{{ scope.row.language === 'en' ? $t('common.langEn') : $t('common.langZh') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('pushes.colStatus')" width="90">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="mini">{{ getStatusName(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sentAt" :label="$t('pushes.colSentAt')" width="170"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { getList } from '@/api/pushes'

export default {
  name: 'Pushes',
  data() {
    return {
      stats: {},
      list: [],
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      search: {
        status: '',
        type: '',
        language: '',
        keyword: '',
        studyId: '',
        nickname: '',
        dateRange: null
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 加载推送列表
    loadData() {
      this.loading = true
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.search.status,
        type: this.search.type,
        language: this.search.language,
        keyword: this.search.keyword,
        studyId: this.search.studyId,
        nickname: this.search.nickname
      }
      if (this.search.dateRange && this.search.dateRange.length === 2) {
        params.startDate = this.search.dateRange[0]
        params.endDate = this.search.dateRange[1]
      }
      getList(params).then(res => {
        this.list = res.data.list || []
        this.total = res.data.total || 0
        this.stats = res.data.stats || {}
      }).catch(() => {
        this.$message.error(this.$t('pushes.loadFail'))
      }).finally(() => {
        this.loading = false
      })
    },
    // 搜索
    handleSearch() {
      this.page = 1
      this.loadData()
    },
    // 重置搜索
    resetSearch() {
      this.search = { status: '', type: '', language: '', keyword: '', studyId: '', nickname: '', dateRange: null }
      this.page = 1
      // 强制 dateRange 回到 null，避免 el-date-picker 残留旧默认值
      this.$nextTick(() => {
        this.loadData()
      })
    },
    // 状态标签类型
    getStatusType(status) {
      const map = { sent: 'success', read: 'primary' }
      return map[status] || 'info'
    },
    // 状态名称
    getStatusName(status) {
      const map = { sent: this.$t('pushes.sent'), read: this.$t('pushes.read') }
      return map[status] || status
    },
    // 分页
    handlePageChange(page) {
      this.page = page
      this.loadData()
    }
  }
}
</script>

<style scoped>
.stat-row {
  margin-bottom: 20px;
}
.stat-card {
  text-align: center;
  padding: 10px 0;
}
.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}
.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 5px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}
.search-form {
  margin-bottom: 15px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
